import React from 'react';

import { QuestionProps } from '../Template/types';
import Select, { OptionType } from 'components/Inputs/Select';
import * as Question from 'components/Question';

type QuestionSelectProps<T> = QuestionProps<T> & {
  options?: OptionType[];
  readOnly?: boolean;
  isNested?: boolean;
  nestedData?: any[];
  currentProductSuiteId?: number;
  value?: any;
  selectBoxDataCallback?: ({}: any) => void;
};

function Component<T>({
  control,
  disabled,
  help,
  showHelpOnClick,
  isSubmitting,
  label,
  options,
  question,
  readOnly,
  nestedData,
  currentProductSuiteId,
  selectBoxDataCallback,
  isNested,
}: QuestionSelectProps<T>) {
  return (
    <Question.Template
      control={control}
      help={help}
      showHelpOnClick={showHelpOnClick}
      label={label}
      question={question}
    >
      {({ invalid, name, onBlur, onChange, ref, value }) => (
        <Select
          ariaLabel={label}
          disabled={
            (options && options.length === 0 && !isNested) ||
            options === undefined
          }
          forwardedRef={ref}
          isNested={isNested}
          nestedData={nestedData}
          currentProductSuiteId={currentProductSuiteId}
          invalid={invalid}
          label={label}
          name={name}
          onBlur={onBlur}
          onChange={onChange}
          options={options}
          selectBoxDataCallback={selectBoxDataCallback}
          readOnly={isSubmitting || readOnly}
          tabIndex={disabled ? -1 : 0}
          value={value}
        />
      )}
    </Question.Template>
  );
}

export default React.memo(Component) as typeof Component;
